import type { NavigationGuardReturn, RouteLocationNormalized } from 'vue-router';

import { useAuthStore } from '@/entities/auth';
import { capturePushReturnIntent } from '@/features/push-navigation';

/**
 * Guard для проверки авторизации пользователя
 * Проверяет meta.requiresAuth (по умолчанию true) и meta.onlyGuest
 */
export const authGuard = (to: RouteLocationNormalized): NavigationGuardReturn => {
  const authStore = useAuthStore();
  const isAuthenticated = authStore.isAuthenticated;

  const requiresAuth = to.meta.requiresAuth ?? true;
  const onlyGuest = to.meta.onlyGuest === true;

  // Страницы только для гостей (например, логин)
  if (onlyGuest && isAuthenticated) {
    return { name: 'home.index' };
  }

  // Страницы требующие авторизации
  if (requiresAuth && !isAuthenticated && to.name !== 'auth.login') {
    capturePushReturnIntent(to);
    return { name: 'auth.login' };
  }

  return true;
};
